import { render, staticRenderFns } from "./AddToCartInput.vue?vue&type=template&id=8849e394"
import script from "./AddToCartInput.vue?vue&type=script&lang=js"
export * from "./AddToCartInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports